import { render } from "./BwofTemplate.vue?vue&type=template&id=3bdb05cd&ts=true"
import script from "./BwofTemplate.vue?vue&type=script&lang=ts"
export * from "./BwofTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__